export type BackgroundTheme =
  | 'mesh_aurora' | 'warm_sunset' | 'ocean_calm' | 'sage_forest' | 'midnight_velvet' | 'pastel_clean';

export type ThemeMode = 'light' | 'dark' | 'auto';

export const BACKGROUND_THEMES: Record<BackgroundTheme, { label: string; swatch: string }> = {
  mesh_aurora: { label: 'Aura Mesh', swatch: 'bg-gradient-to-br from-blue-200 via-indigo-100 to-rose-200' },
  warm_sunset: { label: 'Sunset Glow', swatch: 'bg-gradient-to-br from-amber-200 via-rose-200 to-orange-200' },
  ocean_calm: { label: 'Ocean Calm', swatch: 'bg-gradient-to-br from-sky-200 via-cyan-100 to-blue-200' },
  sage_forest: { label: 'Sage Forest', swatch: 'bg-gradient-to-br from-emerald-200 via-teal-100 to-lime-200' },
  midnight_velvet: { label: 'Midnight Sky', swatch: 'bg-gradient-to-br from-slate-900 via-indigo-950 to-slate-950' },
  pastel_clean: { label: 'Material Clean', swatch: 'bg-gradient-to-br from-slate-100 via-gray-50 to-slate-200' },
};

export type CategoryKey = 'vakantie' | 'project' | 'jubileum' | 'verjaardag' | 'persoonlijk' | 'herinnering';

export interface CategoryTheme {
  label: string;
  cardBg: string;
  cardBgDark: string;
  textColor: string;
  accent: string;
  pillBg: string;
  timerBoxBg: string;
}

/** Kaartkleuren per categorie: semi-transparant, zodat de mesh-achtergrond doorschijnt. */
export const CATEGORY_THEMES: Record<CategoryKey, CategoryTheme> = {
  vakantie: { label: 'Vakantie', cardBg: 'bg-sky-100/90', cardBgDark: 'dark:bg-sky-950/70', textColor: 'text-sky-950 dark:text-sky-100', accent: 'text-sky-800 dark:text-sky-300', pillBg: 'bg-sky-200/80 dark:bg-sky-900/60', timerBoxBg: 'bg-sky-200/50 dark:bg-sky-900/40' },
  project: { label: 'Project', cardBg: 'bg-indigo-100/90', cardBgDark: 'dark:bg-indigo-950/70', textColor: 'text-indigo-950 dark:text-indigo-100', accent: 'text-indigo-800 dark:text-indigo-300', pillBg: 'bg-indigo-200/80 dark:bg-indigo-900/60', timerBoxBg: 'bg-indigo-200/50 dark:bg-indigo-900/40' },
  jubileum: { label: 'Jubileum', cardBg: 'bg-rose-100/90', cardBgDark: 'dark:bg-rose-950/70', textColor: 'text-rose-950 dark:text-rose-100', accent: 'text-rose-800 dark:text-rose-300', pillBg: 'bg-rose-200/80 dark:bg-rose-900/60', timerBoxBg: 'bg-rose-200/50 dark:bg-rose-900/40' },
  verjaardag: { label: 'Verjaardag', cardBg: 'bg-amber-100/90', cardBgDark: 'dark:bg-amber-950/70', textColor: 'text-amber-950 dark:text-amber-100', accent: 'text-amber-800 dark:text-amber-300', pillBg: 'bg-amber-200/80 dark:bg-amber-900/60', timerBoxBg: 'bg-amber-200/50 dark:bg-amber-900/40' },
  persoonlijk: { label: 'Persoonlijk', cardBg: 'bg-emerald-100/90', cardBgDark: 'dark:bg-emerald-950/70', textColor: 'text-emerald-950 dark:text-emerald-100', accent: 'text-emerald-800 dark:text-emerald-300', pillBg: 'bg-emerald-200/80 dark:bg-emerald-900/60', timerBoxBg: 'bg-emerald-200/50 dark:bg-emerald-900/40' },
  herinnering: { label: 'Herinnering', cardBg: 'bg-purple-100/90', cardBgDark: 'dark:bg-purple-950/70', textColor: 'text-purple-950 dark:text-purple-100', accent: 'text-purple-800 dark:text-purple-300', pillBg: 'bg-purple-200/80 dark:bg-purple-900/60', timerBoxBg: 'bg-purple-200/50 dark:bg-purple-900/40' },
};

/** Auto: volg het systeem, met fallback naar donker tussen 20:00 en 07:00. */
export function isDarkModeActive(mode: ThemeMode): boolean {
  if (mode === 'dark') return true;
  if (mode === 'light') return false;
  if (window.matchMedia?.('(prefers-color-scheme: dark)').matches) return true;
  const hour = new Date().getHours();
  return hour >= 20 || hour < 7;
}
